const styles = (theme) => ({
  containerPaper: {
    borderRadius: 3,
    minWidth: "200px",
    height: "100%",
    padding: "10px",
    display: "flex",
    flexDirection: "column",

    gap: 0.5,
    position: "relative",
    overflow: "hidden",
    borderTop: `none `,
  },
  titleValue: {
    fontWeight: "bold",
    fontSize: "20px",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",

  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  speedIcon: {
    position: "absolute",
    bottom: 0,
    right: 8,
    fontSize: 80,
    color: "grey.500",
    opacity: 0.1,
    pointerEvents: "none",
    zIndex: 0,
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: "14px",
    color: theme.palette.white.main,
  },
  containerIconCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
  },
  containerBodyCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    gap: 2,
  },
});

export default styles;
